// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"4f35489d","787":"f4b1d36b"}[chunkId] + ".chunk.js";
};